import { isEmpty } from 'lodash-es';

import { Source } from 'shared/types/source';
import { Validator } from 'shared/components/MultiStepForm/types';
import { SOURCE_COUNT_LIMIT } from './constants';

const validator: Validator<Source[]> = sources => {
    if (!sources || isEmpty(sources) || sources.length > SOURCE_COUNT_LIMIT) {
        return `Select no more than ${SOURCE_COUNT_LIMIT} sources to continue.`;
    }

    const hasSourceWithoutWeight = sources.some(source => !source.weight);
    if (hasSourceWithoutWeight) {
        return 'Select a weight for the sources that do not have it to continue.';
    }
};

export default validator;
